import { render, staticRenderFns } from "./image-upload.vue?vue&type=template&id=6c5ba500&scoped=true&"
import script from "./image-upload.vue?vue&type=script&lang=tsx&"
export * from "./image-upload.vue?vue&type=script&lang=tsx&"
import style0 from "./image-upload.vue?vue&type=style&index=0&id=6c5ba500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ba500",
  null
  
)

export default component.exports